


















import { listFactory } from '@/main/pages';
import { isMultipleWorkshopSelected, getSearchButtonLabel, handleMultiWorkshopFilter, validateDateFields,getCurrentLanguageId } from '@/main/utils/commonFunctions';
import { showAlert } from '@/main/utils/notifications';
import { getColumnsNames } from '@/main/utils/table';

import { NAME } from './constants';
import { store } from './store/list';
import { apiProvider } from './api';

export default listFactory(NAME, store).extend({
	data() {
		return {
			realTimeInventoryParams: 'null' as string,
			selectedWorkshops: [] as number[],
		};
	},
	methods: {
	GetRealTimeInventoryParameters(OrganizationIds: any[]) {
		if (OrganizationIds.length > 0) {		
			let params = '';
			OrganizationIds.forEach((id: any, index: number) => {			
				params += `${index > 0 ? '&' : ''}OrganizationIds=${id}`;
			});
			return params;
		}
    },

		resetOrganizationId() {
            this.realTimeInventoryParams = "";
		},
		async filterClick() {			
			await handleMultiWorkshopFilter(
				this,
				NAME,
				this.OrganizationIds,
				(columnsSeq) => ({
					OrganizationIds: this.OrganizationIds,					
					ColumnSequence: getColumnsNames(this.table.columns.filter(x => x.isVisible === true)).join(','),
					LanguageId: getCurrentLanguageId(this.loggedUser.UzivatelData.LanguageId),
				}),
			);
		},

		async exportFun() {
			try {
				if (this.filter.OrganizationIds == null || this.filter.OrganizationIds.length === 0) {
					this.showErrorAlert({ message: this.LocalizePopisPoli('DEALER_CODE_NOT_NULL') });
					return;
				}
				const getColumnsSequence = getColumnsNames(this.table.columns.filter(x => x.isVisible === true));
				this.startLoading();
				const params = this.GetRealTimeInventoryParameters(this.OrganizationIds);
				if (this.isMultipleWorkshopSelected) {
					this.showErrorAlert({
						message: this.LocalizeChyboveHlasky('MultiWorkshopExportDisabled'),
					});
				} else {
				await apiProvider.GetRealtimeInventoryReport(params,getCurrentLanguageId(this.loggedUser.UzivatelData.LanguageId), getColumnsSequence);
				this.resetOrganizationId();
				}
			}catch (error) {
				showAlert({
					message: this.LocalizeChyboveHlasky('LocalMsg'),
					title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
					options: {
						type: 'error',
					},
				});
			} finally {
				this.endLoading();
			}
		},
	},
	mounted() {
		const element = document.getElementsByClassName('el-main');
		if (element.length !== 0) {
			element[0].classList.remove('d-flex');
		}
	},
	computed:{
		isMultipleWorkshopSelected(): boolean {
			return isMultipleWorkshopSelected(this.OrganizationIds);
		},
		searchButtonLabelKey(): string {
			return getSearchButtonLabel(this.OrganizationIds);
		},
	}
});
